import axios from 'axios'
import Qs from 'qs'
import Router from '@/router'
import Store from '@/store'

class Http {
  config() {
    // 基础配置
    const config = {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return config
  }

  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      request => {
        // 配置请求参数
        let requestData = request.parameters || {}
        if (request.headers['Content-Type'] === 'multipart/form-data') {
          requestData = requestData.formData
        }
        if (request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
          requestData = Qs.stringify(requestData, { allowDots: true, arrayFormat: 'repeat' })
          if (request.method === 'get') {
            request.url = `${request.url}${requestData ? `?${requestData}` : ''}`
          } else request.data = requestData
        } else {
          if (request.method === 'get') request.params = requestData
          else request.data = requestData
        }
        return request
      },
      error => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      res => {
        // 根据返回码执行响应逻辑
        // 登录已失效则退出
        if (
          [2002, 2003].indexOf(res.data.code) > -1 &&
          !res.config.url.includes('/wx/user/wxc1710c833df6b777/userInfo')
        ) {
          setTimeout(() => {
            Store.commit('SET_STATUS', undefined)
            Router.push('/login')
          }, 1000)
        }
        return res.data
      },
      error => {
        return Promise.reject(error)
      }
    )
  }

  request(options) {
    // 实例化
    const instance = axios.create()
    // 合并配置
    const config = this.config()
    const headers = Object.assign({}, config.headers, options.headers)
    options = Object.assign(config, options)
    options.headers = headers
    // 拦截器
    this.interceptors(instance)
    return instance(options)
  }
}

export default Http
